/** All registered sourceId / reasonId prefixes. Games use their own prefix (e.g. 'blockjam_'). */
export const VALID_PREFIXES = new Set([
    'blockjam_',
    'watersort_',
    'wordsearch_',
    'daily_',
    'shop_',
    'lobby_',
    'system_',
    'test_',
]);
export function hasValidPrefix(id) {
    for (const prefix of VALID_PREFIXES) {
        if (id.startsWith(prefix))
            return true;
    }
    return false;
}
